// extracted by mini-css-extract-plugin
export default {"productGallery":"AM-z","inQuickShop":"BM-z"};